module.exports = __webpack_public_path__ + "static/img/FadzriSentosa.230f4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/FadzriSentosa.png
// module id = j8HS
// module chunks = 36